import React from 'react'

const debug = false
// const debug = "FieldTimeReported_PickerValueNotEmpty"

export default function FieldTimeReported_PickerValueNotEmpty(props:any) {

    const displayValue = props.field.getDisplayValue(props.value)

    const onReset = (e:any) => {
        e.stopPropagation()
        props.onChange(null)
    }

    debug && console.log(debug, 'render', displayValue, props.value)

    return (
        <div className="ui5-field-picker" onClick={props.onClick}>

            <div className={Classes("icon m-l-8 m-r-5", props.field.icon, props.options?.iconClass)}/>

            <div className="m-r-8 ui5-txt-less-important-small">{displayValue}</div>

            <div className="ui5-btn-reset m-t-2 m-r-8" onClick={onReset}/>

            {props.children}
        </div>
    )

}
